const note = {
    version: '1.2.0',
    date: '2026-09-09',
    tags: ['Forbedret', 'Fix'],
    body: `
- **Timelogs, som er slettet i CapLegal, forsvinder fra kalenderen.** De blev stående og talte med i dagens timer.
`,
};

export default note;
